import { UnstyledButton } from '@shared/ui/unstyled-button';
import { ChevronDownSmallIcon } from '@shared/assets/icons';
import { useEffect, useRef, useState } from 'react';
import { Popover } from '@shared/ui/popover';
import stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import { styles } from './styles';

interface Item {
  value: string;
  label: string;
  className?: string;
}

interface TagProps {
  items?: Item[];
  onChange?: (value: string) => void;
  selectedValue?: string;
  isDisabled?: boolean;
}

export const Tag = ({ items, onChange, selectedValue, isDisabled = false }: TagProps) => {
  const selectedItem = items?.find(({ value }) => value === selectedValue);
  const containerProps = stylex.props(styles.container);
  const [dropdownWidth, setDropdownWidth] = useState<number | null>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isOpenTag, setIsOpenTag] = useState(false);

  const onClickTag = () => {
    if (isDisabled) return;
    setIsOpenTag(!isOpenTag);
  };

  const onChangeTag = (value: string) => {
    setIsOpenTag(false);
    onChange?.(value);
  };

  useEffect(() => {
    if (buttonRef.current) {
      const width = buttonRef.current.offsetWidth;
      setDropdownWidth(width);
    }
  }, [selectedValue]);

  return (
    <>
      <UnstyledButton
        {...containerProps}
        className={clsx(containerProps.className, selectedItem?.className)}
        ref={buttonRef}
        onClick={onClickTag}
      >
        {selectedItem?.label}
        {!isDisabled && <ChevronDownSmallIcon width="16" height="16" color="currentColor" />}
      </UnstyledButton>

      {items && (
        <Popover
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          anchorRef={buttonRef}
          open={isOpenTag}
          onClose={() => setIsOpenTag(false)}
          {...stylex.props(styles.popover(dropdownWidth))}
        >
          <div {...stylex.props(styles.menuList)}>
            {items.map(({ value, label }) => (
              <UnstyledButton
                key={value}
                onClick={() => onChangeTag?.(value)}
                {...stylex.props(styles.item, value === selectedValue && styles.selectedItem)}
              >
                {label}
              </UnstyledButton>
            ))}
          </div>
        </Popover>
      )}
    </>
  );
};
